var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Store } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { ADD_NUMBERS_TO_BLACKLIST, ADD_NUMBERS_TO_BLACKLIST_SUCCESS, AddNumbersToBlacklistFailureAction, AddNumbersToBlacklistSuccessAction, ClearInfoInBlacklistAction, EXPAND_MSISDN, GET_BLACKLIST, GET_INFO_IN_BLACKLIST, GetBlacklistAction, GetBlacklistFailureAction, GetBlacklistSuccessAction, GetInfoInBlacklistAction, GetInfoInBlacklistFailureAction, GetInfoInBlacklistSuccessAction, IMPORT_FILE_TO_BLACKLIST, IMPORT_FILE_TO_BLACKLIST_FAILURE, IMPORT_FILE_TO_BLACKLIST_SUCCESS, ImportFileToBlacklistFailureAction, ImportFileToBlacklistSuccessAction, REMOVE_NUMBERS_TO_BLACKLIST, REMOVE_NUMBERS_TO_BLACKLIST_SUCCESS, RemoveNumbersToBlacklistFailureAction, RemoveNumbersToBlacklistSuccessAction } from './blacklist.actions';
import { BlacklistService } from './blacklist.service';
import { of } from 'rxjs/observable/of';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { getBlacklistParamsSelector } from './blacklist.reducer';
import { NotificationService } from '../../shared/notification.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { isValidPhoneNumber } from '../../shared/utils/validate-number';
import { checkImportFileFormat } from '../../shared/utils/file-utils';
var BlacklistEffects = /** @class */ (function () {
    function BlacklistEffects(actions$, blacklistService, notificationService, permissionsService, store) {
        var _this = this;
        this.actions$ = actions$;
        this.blacklistService = blacklistService;
        this.notificationService = notificationService;
        this.permissionsService = permissionsService;
        this.store = store;
        this.getBlacklist$ = this.actions$.pipe(ofType(GET_BLACKLIST), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.blacklistService
                .blacklist(payload)
                .pipe(map(function (response) { return new GetBlacklistSuccessAction(response); }), catchError(function (error) { return of(new GetBlacklistFailureAction(error)); }));
        }));
        this.expandMsisdn$ = this.actions$.pipe(ofType(EXPAND_MSISDN), map(function (payload) {
            return payload.payload.expanded
                ? new GetInfoInBlacklistAction(payload.payload)
                : new ClearInfoInBlacklistAction(payload.payload);
        }));
        this.getInfoInBlacklist$ = this.actions$.pipe(ofType(GET_INFO_IN_BLACKLIST), switchMap(function (payload) {
            return _this.blacklistService
                .info(payload.payload.element.msisdn)
                .pipe(map(function (response) { return new GetInfoInBlacklistSuccessAction(response); }), catchError(function (error) { return of(new GetInfoInBlacklistFailureAction(error)); }));
        }));
        this.addNumbersToBlacklist$ = this.actions$.pipe(ofType(ADD_NUMBERS_TO_BLACKLIST), filter(this.filterNumber('BLACKLIST.ADD_CONTACTS.INVALID_NUMBERS')), switchMap(function (payload) {
            return _this.blacklistService
                .addNumbersToBlackList(payload.payload)
                .pipe(map(function (response) { return new AddNumbersToBlacklistSuccessAction(response); }), catchError(function (error) { return of(new AddNumbersToBlacklistFailureAction(error)); }));
        }));
        this.addNumbersToBlacklistSuccess$ = this.actions$.pipe(ofType(ADD_NUMBERS_TO_BLACKLIST_SUCCESS), tap(function (response) {
            var count = response.payload.length;
            _this.notificationService.open(count === 1 ? 'BLACKLIST.SUCCESS_ADD_NUMBER' : 'BLACKLIST.SUCCESS_ADD_NUMBERS', {
                count: count
            });
        }), switchMap(function () { return _this.permissionsService.hasPermission('BLACKLIST_PERMISSION'); }), filter(function (permission) { return permission; }), withLatestFrom(this.store.select(getBlacklistParamsSelector)), map(function (_a) {
            var payload = _a[0], params = _a[1];
            return new GetBlacklistAction(params);
        }));
        this.removeNumbersToBlacklist$ = this.actions$.pipe(ofType(REMOVE_NUMBERS_TO_BLACKLIST), filter(this.filterNumber('BLACKLIST.REMOVE_CONTACTS.INVALID_NUMBERS')), switchMap(function (payload) {
            return _this.blacklistService
                .removeNumbersToBlackList(payload.payload)
                .pipe(map(function (response) { return new RemoveNumbersToBlacklistSuccessAction(response); }), catchError(function (error) { return of(new RemoveNumbersToBlacklistFailureAction(error)); }));
        }));
        this.removeNumbersToBlacklistSuccess$ = this.actions$.pipe(ofType(REMOVE_NUMBERS_TO_BLACKLIST_SUCCESS), tap(function (response) {
            var count = response.payload.length;
            _this.notificationService.open(count === 1 ? 'BLACKLIST.SUCCESS_REMOVE_NUMBER' : 'BLACKLIST.SUCCESS_REMOVE_NUMBERS', { count: count });
        }), withLatestFrom(this.store.select(getBlacklistParamsSelector)), map(function (_a) {
            var payload = _a[0], params = _a[1];
            return new GetBlacklistAction(params);
        }));
        this.importFileToBlacklist$ = this.actions$.pipe(ofType(IMPORT_FILE_TO_BLACKLIST), filter(this.filterImportFile('IMPORTS.WRONG_FILE_FORMAT')), switchMap(function (payload) {
            return _this.blacklistService.importFileToBlacklist(payload.payload).pipe(map(function (response) {
                return new ImportFileToBlacklistSuccessAction({
                    import: payload.payload,
                    response: response
                });
            }), catchError(function (error) { return of(new ImportFileToBlacklistFailureAction(error)); }));
        }));
        this.importFileToBlacklistSuccess$ = this.actions$.pipe(ofType(IMPORT_FILE_TO_BLACKLIST_SUCCESS), tap(function (payload) {
            var count = payload.payload.response.numbersCount - payload.payload.response.rejectedNumbersCount;
            _this.notificationService.open(count === 1
                ? "BLACKLIST.SUCCESS_" + payload.payload.import.action + "_NUMBER"
                : "BLACKLIST.SUCCESS_" + payload.payload.import.action + "_NUMBERS", { count: count });
        }));
        this.importFileToBlacklistFailure$ = this.actions$.pipe(ofType(IMPORT_FILE_TO_BLACKLIST_FAILURE), tap(function (err) {
            var error = err.payload.error;
            if (error instanceof Array) {
                _this.notificationService.open(error[0], {}, _this.notificationService.getDefaultCloseAction());
            }
            else {
                _this.notificationService.open('IMPORTS.WRONG_FORMAT', {}, _this.notificationService.getDefaultCloseAction());
            }
        }));
    }
    BlacklistEffects.prototype.filterNumber = function (errorMessage) {
        var _this = this;
        return function (payload) {
            var isPhoneNumbersValid = payload.payload.every(function (number) { return isValidPhoneNumber(number); });
            if (!isPhoneNumbersValid) {
                _this.notificationService.open(errorMessage, {
                    numbers: payload.payload.filter(function (number) { return !isValidPhoneNumber(number); }).join(', ')
                }, _this.notificationService.getDefaultCloseAction());
            }
            return isPhoneNumbersValid;
        };
    };
    BlacklistEffects.prototype.filterImportFile = function (errorMessage) {
        var _this = this;
        return function (payload) {
            var fileName = payload.payload.fileForm.get('file').name;
            if (checkImportFileFormat(fileName)) {
                return true;
            }
            else {
                _this.notificationService.open(errorMessage, {}, _this.notificationService.getDefaultCloseAction());
                return false;
            }
        };
    };
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "getBlacklist$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "expandMsisdn$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "getInfoInBlacklist$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "addNumbersToBlacklist$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "addNumbersToBlacklistSuccess$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "removeNumbersToBlacklist$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "removeNumbersToBlacklistSuccess$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "importFileToBlacklist$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "importFileToBlacklistSuccess$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], BlacklistEffects.prototype, "importFileToBlacklistFailure$", void 0);
    return BlacklistEffects;
}());
export { BlacklistEffects };
